
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/cookie-policy",
      function () {
        return require("private-next-pages/[market]/[language]/cookie-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/cookie-policy"])
      });
    }
  